import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomTracker } from 'src/app/data/dietitian/domain/custom_tracker/custom_tracker';
import { CustomTrackerCommands } from 'src/app/data/dietitian/domain/custom_tracker/custom_tracker_commands';
import {
  DietitianState,
  DietitianStateProvider,
} from 'src/app/data/dietitian/domain/dietitian_state_provider';

import { CustomTrackerEventProvider } from '../../../../../../data/patient/domain/events/custom_tracker/custom_tracker_event_provider';
import { CustomTrackerEvent } from '../../../../../../data/patient/domain/events/custom_tracker/custom_tracker_events';
import { DiaryType } from '../../../../../../data/tracker/domain/diary_type/diary_type';

@Injectable()
export class CustomTrackersListFacade {
  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private customTrackerEventProvider: CustomTrackerEventProvider,
    private customTrackerCommands: CustomTrackerCommands,
  ) {
    // do nothing
  }

  get dietitianState$(): Observable<DietitianState> {
    return this.dietitianStateProvider.state$;
  }

  get customTrackerEvent$(): Observable<CustomTrackerEvent> {
    return this.customTrackerEventProvider.events$;
  }

  deleteCustomTracker(dietitianId: string, customTrackerId: string) {
    return this.customTrackerCommands.deleteTracker(
      dietitianId,
      customTrackerId,
    );
  }

  async getDietitianCustomTrackers(
    dietitianId: string,
  ): Promise<CustomTracker[]> {
    return this.customTrackerCommands.getDietitianCustomTrackers(dietitianId);
  }

  async findAllDiaryTypes(): Promise<DiaryType[]> {
    return this.customTrackerCommands.findAllDiaryTypes();
  }
}
